webpackJsonp([4435655529797],{

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackgroundVideo = function (_Component) {
	    _inherits(BackgroundVideo, _Component);
	
	    function BackgroundVideo() {
	        _classCallCheck(this, BackgroundVideo);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    BackgroundVideo.prototype.render = function render() {
	        var _props = this.props,
	            src = _props.src,
	            muted = _props.muted,
	            loop = _props.loop,
	            autoPlay = _props.autoPlay,
	            controls = _props.controls,
	            playsInline = _props.playsInline;
	
	
	        return _react2.default.createElement(
	            "div",
	            { className: "background-video" },
	            _react2.default.createElement(
	                "video",
	                { controls: controls ? true : false,
	                    muted: muted ? true : false,
	                    loop: loop ? true : false,
	                    autoPlay: autoPlay ? true : false,
	                    playsInline: playsInline ? true : false },
	                _react2.default.createElement("source", { src: src, type: "video/mp4" })
	            )
	        );
	    };
	
	    return BackgroundVideo;
	}(_react.Component);
	
	exports.default = BackgroundVideo;
	module.exports = exports["default"];

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _BackgroundVideo = __webpack_require__(335);
	
	var _BackgroundVideo2 = _interopRequireDefault(_BackgroundVideo);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Testimonials = __webpack_require__(130);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _AdmissionsSignup = __webpack_require__(129);
	
	var _AdmissionsSignup2 = _interopRequireDefault(_AdmissionsSignup);
	
	var _Signup = __webpack_require__(70);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Fellows = __webpack_require__(296);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _gsap = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import gsap from 'gsap'
	// import {TweenMax, Power2, TimelineLite, TimelineMax, TweenLite} from "gsap/TweenMax"
	
	
	var ScrollMagic;
	if (typeof window === 'object') {
	    ScrollMagic = __webpack_require__(24);
	
	    // import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
	    // require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
	}
	
	var RedesignOverview = function (_React$Component) {
	    _inherits(RedesignOverview, _React$Component);
	
	    function RedesignOverview(props) {
	        _classCallCheck(this, RedesignOverview);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            mainVideoPlay: false
	        };
	        return _this;
	    }
	
	    RedesignOverview.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.controller = new ScrollMagic.Controller();
	
	        this.setState({
	            controller: this.controller
	        });
	
	        var timeline = this.refs.timeline;
	        if (timeline) {
	            var blocks = Array.from(timeline.getElementsByClassName('block'));
	            var timelineIndicator = this.refs.timelineBar;
	            var TL = new _gsap.TimelineMax();
	
	            TL.to(timelineIndicator, 0.5, { height: timeline.clientHeight, ease: 'Linear' });
	
	            var timelineScroll = new ScrollMagic.Scene({
	                triggerElement: timeline,
	                triggerHook: 0.5,
	                duration: timeline.clientHeight * 1.15
	            })
	            // .setTween(TL)
	            .addTo(this.controller);
	
	            blocks.map(function (b, index) {
	                var activateSections = new ScrollMagic.Scene({
	                    triggerElement: b,
	                    triggerHook: 0.5
	                }).setClassToggle(b, 'show').addTo(_this2.controller);
	                // .addIndicators()
	            });
	        }
	    };
	
	    RedesignOverview.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.state.controller.destroy(true);
	        this.controller.destroy(true);
	    };
	
	    RedesignOverview.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props$data = this.props.data,
	            page = _props$data.page,
	            fellows = _props$data.fellows;
	
	        var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
	        var pageData = this.props.pathContext.data;
	
	        // console.log('THE DATA == ', pageData);
	        return _react2.default.createElement(
	            'div',
	            { className: 'overview-template page-redesign' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero', style: { background: 'url(' + pageData.heroImage.file.url + ') center no-repeat', backgroundSize: 'cover' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'video-bg' },
	                    pageData.heroMiniReel && _react2.default.createElement(_BackgroundVideo2.default, { src: pageData.heroMiniReel, playsInline: true, loop: true, muted: true, autoPlay: true })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content-wrapper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('h1', { className: 'h1 large', dangerouslySetInnerHTML: { __html: pageData.headline } })
	                        ),
	                        pageData.heroFullReel && _react2.default.createElement(_Button2.default, { text: 'Watch the video', onClick: function onClick() {
	                                return _this3.setState({ mainVideoPlay: true });
	                            } })
	                    )
	                ),
	                this.state.mainVideoPlay && _react2.default.createElement(
	                    'div',
	                    { className: 'fixed-video' },
	                    _react2.default.createElement(
	                        'video',
	                        { playsInline: true, autoPlay: true, controls: 'true' },
	                        _react2.default.createElement('source', { src: pageData.heroFullReel })
	                    ),
	                    _react2.default.createElement('div', { className: 'close', onClick: function onClick() {
	                            return _this3.setState({ mainVideoPlay: false });
	                        } })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block intro-spacing' },
	                    _react2.default.createElement('h2', { className: 'h2 no-transform', dangerouslySetInnerHTML: { __html: pageData.introContent.introContent } })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block block-split-link custom-grid-7-5' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item standard-spacing bg-grey' },
	                        _react2.default.createElement('h3', { className: 'h1 medium', dangerouslySetInnerHTML: { __html: pageData.linkSectionHeadline } }),
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: pageData.linkSectionContent.linkSectionContent } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item standard-spacing bg-black-light' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content-wrapper' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content' },
	                                _react2.default.createElement('h3', { style: { marginBottom: '30px' }, className: 'no-transform color-white', dangerouslySetInnerHTML: { __html: pageData.linkSectionSecondaryHeadline } }),
	                                _react2.default.createElement(_Button2.default, { text: pageData.linkSectionLink.text, href: pageData.linkSectionLink.link })
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block block-list-custom-details standard-spacing grid-4 grid-tablet-2' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'headline-with-accent ' + pageData.interestFormColor.interestFormColor.toLowerCase() },
	                            _react2.default.createElement('strong', { dangerouslySetInnerHTML: { __html: pageData.accentHeadline1 } })
	                        ),
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: pageData.accentContent1.accentContent1 } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'headline-with-accent ' + pageData.interestFormColor.interestFormColor.toLowerCase() },
	                            _react2.default.createElement('strong', { dangerouslySetInnerHTML: { __html: pageData.accentHeadline2 } })
	                        ),
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: pageData.accentContent2.accentContent2 } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'headline-with-accent ' + pageData.interestFormColor.interestFormColor.toLowerCase() },
	                            _react2.default.createElement('strong', { dangerouslySetInnerHTML: { __html: pageData.accentHeadline3 } })
	                        ),
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: pageData.accentContent3.accentContent3 } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'headline-with-accent ' + pageData.interestFormColor.interestFormColor.toLowerCase() },
	                            _react2.default.createElement('strong', { dangerouslySetInnerHTML: { __html: pageData.accentHeadline4 } })
	                        ),
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: pageData.accentContent4.accentContent4 } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block block-strokes-with-headline' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement('img', { src: '/images/' + pageData.interestFormColor.interestFormColor + '-strokes-wide.png', alt: 'Green stroke', className: 'redesign-strokes' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'h1 large standard-spacing' },
	                        'Why ',
	                        pageData.headline
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'timeline-container', ref: 'timeline' },
	                    _react2.default.createElement('div', { className: 'progress-indicator', ref: 'timelineBar' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block bottom-spacer grid-2 grid-tablet-1 grid-gap-90' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-wrapper standard-spacing' },
	                                _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: pageData.whyBlockContent1.whyBlockContent1 } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: pageData.whyBlockImage1.file.url, alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block bottom-spacer grid-2 grid-tablet-1 grid-gap-90 tablet-reverse' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: pageData.whyBlockImage2.file.url, alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-wrapper standard-spacing' },
	                                _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: pageData.whyBlockContent2.whyBlockContent2 } })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block bottom-spacer grid-2 grid-tablet-1 grid-gap-90' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'content-wrapper standard-spacing' },
	                                _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: pageData.whyBlockContent3.whyBlockContent3 } })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'item' },
	                            _react2.default.createElement('img', { src: pageData.whyBlockImage3.file.url, alt: '' })
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'block standard-spacing', style: { maxWidth: '1200px' }, dangerouslySetInnerHTML: { __html: pageData.fullWidthContentSection.fullWidthContentSection } })
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block block-quote-story-link standard-spacing grid-2 grid-tablet-1' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item standard-spacing' },
	                        _react2.default.createElement('img', { src: pageData.storyLinkAuthor.file.url, className: 'headshot', alt: '' }),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'large' },
	                            _react2.default.createElement('strong', { dangerouslySetInnerHTML: { __html: pageData.storyLinkHeadline } })
	                        ),
	                        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: pageData.storyLinkExcerpt.storyLinkExcerpt } }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: pageData.storyLink.link, className: 'hoverlink' },
	                            pageData.storyLink.text
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement('img', { src: pageData.storyLinkImage.file.url, alt: '' })
	                    ),
	                    _react2.default.createElement('img', { src: '/images/' + pageData.interestFormColor.interestFormColor + '-strokes-new.png', alt: 'Blue stroke', className: 'redesign-strokes strokes-top-right-corner', style: { zIndex: 1 } })
	                )
	            ),
	            _react2.default.createElement(_Fellows2.default, {
	                title: 'Experience a day in the life of a Global Citizen Year Fellow',
	                cards: pageData.fellowsCards,
	                link: pageData.storyArchiveLink
	            }),
	            _react2.default.createElement(
	                'section',
	                { style: { zIndex: '50', position: 'relative' }, id: 'signup' },
	                _react2.default.createElement(_Signup2.default, {
	                    title: page.admissionsRfiText ? page.admissionsRfiText : "Sign up for more!",
	                    location: this.props.location,
	                    color: pageData.interestFormColor ? pageData.interestFormColor.interestFormColor : 'Black'
	                })
	            )
	        );
	    };
	
	    return RedesignOverview;
	}(_react2.default.Component);
	
	exports.default = RedesignOverview;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-redesign-overview-js-42be39259b88248d97ad.js